<script lang="ts" setup>
import { GpAvatar, GpTag } from '@gportal/uikit';

withDefaults(
  defineProps<{
    avatarUrl: string;
    name: string;
    id: string;
    isDefaultProject: boolean;
    size: 'sm' | 'small' | 'md' | 'medium' | 'lg' | 'large';
  }>(),
  {
    avatarUrl: '',
    name: '',
    id: '',
    isDefaultProject: false,
    size: 'medium',
  },
);
</script>

<template>
  <div class="tw-flex tw-items-center tw-gap-2">
    <GpAvatar :src="avatarUrl" :alt="name" :size="size" />
    <div class="tw-flex-1 tw-gap-2">
      <router-link :to="{ name: 'ProjectSettings', params: { projectId: id } }">
        {{ name }}
        <GpTag v-if="isDefaultProject" label="default" size="xs" />
      </router-link>
    </div>
  </div>
</template>
